import { useQuery } from '@tanstack/react-query';
import { apiSearch } from './client.ts';
import { queryDefaults } from './queries.ts';
import { useSession } from '../auth/session.tsx';
import type { ClientPage } from './types.ts';

/** How many matches the top bar offers. Beyond that, the client list. */
export const SEARCH_LIMIT = 8;

/**
 * The top bar's client search, over `GET /clients`, which already matches
 * aliases and former names as well as names and refs.
 *
 * Keyed under `clients`, so anything that invalidates the client list
 * invalidates these too. The previous answer is kept on screen while the next
 * one loads, and the search box decides what it may claim — see ClientSearch.
 */
export function useClientSearch(q: string) {
  const { getToken } = useSession();
  return useQuery({
    queryKey: ['clients', 'search', q],
    queryFn: () =>
      apiSearch<ClientPage>('/clients/search', { q, sort: 'last_name', offset: 0, limit: SEARCH_LIMIT }, getToken),
    ...queryDefaults,
    enabled: q.length > 0,
    placeholderData: (previous) => previous,
  });
}
